<template>
    <!-- The tool's five parts. The active one comes from the route; it used to be painted
         through document.getElementById with inline styles. -->
    <div class="calc-subtabs" role="tablist">
        <button v-for="tab in tabs"
                :key="tab.route"
                type="button"
                role="tab"
                class="calc-subtab"
                :class="{ 'is-active': tab.route === $route.name }"
                :aria-selected="tab.route === $route.name ? 'true' : 'false'"
                @click="open(tab.route)">
            {{ tab.label }}
        </button>
        <button v-if="hasSchema" type="button" class="calc-subtab is-icon" title="Info" aria-label="Info" @click="openImage">
            <span class="mdi mdi-information-outline" aria-hidden="true"></span>
        </button>
    </div>
</template>

<script>
    import router from '@/router';

    export default {
        name: 'OutputCircBtns',
        computed: {
            tabs() {
                const c = this.$lang.Calculation;
                return [
                    { route: 'calc_Busbar', label: c.InnerTitle_9 },
                    { route: 'calc_InputCircuit', label: c.InnerTitle_10 },
                    { route: 'calc_OutputCircuit', label: c.InnerTitle_11 },
                    { route: 'calc_Manuel', label: c.InnerTitle_12 },
                    { route: 'calc_Summary', label: c.InnerTitle_13 }
                ];
            },
            // The circuit schema belongs to the busbar and circuit parts, as before.
            hasSchema() {
                return this.$route.name !== 'calc_Manuel' && this.$route.name !== 'calc_Summary';
            }
        },
        methods: {
            open(route) {
                this.$store.state.areHiddenStepsVisible = true;
                this.$store.isPageOpenedFromStepBar = false;
                router.push('/' + route);
            },
            openImage() {
                const h = this.$createElement;
                // At its own proportions (about 5:3); is-4by3 squashed it.
                const vnode = h('img', { attrs: { src: '/img/Psema_output.png', alt: '' }, style: { display: 'block', width: '100%', height: 'auto' } });
                this.$buefy.modal.open({ content: [vnode], width: 1100 });
            }
        }
    };
</script>
